export enum KnowledgeBaseRoutes {
  root = 'knowledge-base',
  createDocument = 'create-document',
  editDocument = 'edit-document',
}
